import { render } from "./LotDetailsConfirmModal.vue?vue&type=template&id=d79b2c2c&ts=true&lang=pug"
import script from "./LotDetailsConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotDetailsConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__